import React, {useContext , useEffect} from 'react';
import AfterPaymentSaveTravel from '../_after_payment_save_travel/_after_payment_save_travel'
import Context from '../../context/context';

function AfterPayment() {

  const {state, dispatch} = useContext(Context);

  useEffect(() => {
    setTimeout(() => {
      document.getElementById('afterPaymentLink').click();
    }, 1000);
  }, []);
  
  console.log("%cAfterPayment state", "color: green", state);
    setTimeout(() => {
      console.log(localStorage)
      console.log(localStorage.getItem('invitationData'))
      const invitationData = JSON.parse(localStorage.getItem('invitationData')); 
      console.log(invitationData) 
        }, 2000);
    //  window.parent.location.href = 'https://pych-customers.web.app/AfterPaymentSaveTravel'


  return (
    <div>
      <a id="afterPaymentLink" target="_parent" href='/AfterPaymentSaveTravel'>click to continue</a>
      {/* <AfterPaymentSaveTravel></AfterPaymentSaveTravel>  */}
    </div>
  )
}

export default AfterPayment